import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
const DataChangeRequestsContext = createContext(undefined);
export const DataChangeRequestsProvider = ({ children, value, }) => (_jsx(DataChangeRequestsContext.Provider, { value: value, children: children }));
export const useDataChangeRequestsContext = () => {
    const context = useContext(DataChangeRequestsContext);
    if (!context) {
        throw new Error('useDataChangeRequestsContext must be used within a DataChangeRequestsProvider');
    }
    return context;
};
export const useDcrApiContext = () => {
    const { apiInstance, environmentId } = useDataChangeRequestsContext();
    return useMemo(() => ({ apiInstance, environmentId }), [apiInstance, environmentId]);
};
